export function normaliseHTMl(html: string) {
    return (
        html
            // Replace truly empty paragraphs with a <br />
            .replace(
                /<p(?:\s[^>]*)?>\s*(?:&nbsp;|\u00A0|&#160;|<br\s*\/?>)?\s*<\/p>/gi,
                '<br />',
            )
            // Replace common NBSP encodings everywhere in the HTML
            .replace(/&nbsp;|&nvsp;|&#160;/gi, ' ')
            .replace(/\u00A0/g, ' ')
    );
}
